import { logger, responseErrorToString } from '@zorro/common-utils';
import { Button } from '@zorro/design-system/v2/Button';
import { Group, Space, Text } from '@zorro/web/design-system';
import {
  showErrorNotification,
  useMonolithMutation,
} from '@zorro/web/ui-utils';

type Props = {
  employerId: string;
  employerName: string;
  onClose: () => void;
};

export const CancelInviteForm = ({
  employerId,
  employerName,
  onClose,
}: Props) => {
  const { mutate: mutateCancleInviteEmployer } = useMonolithMutation({
    method: 'employersControllerCancelInviteEmployerAdmin',
    successMessage: 'Employer invitation cancelled',
  });

  const handleCancelInvite = async () => {
    try {
      await mutateCancleInviteEmployer([employerId]);
      onClose();
    } catch (error) {
      logger.error(error);
      showErrorNotification({ message: responseErrorToString(error) });
    }
  };

  return (
    <>
      <Text mt="lg" fw={500}>
        {`Are you sure you want to cancel the invitation to ${employerName}? They
          won't be able to use the link you shared`}
      </Text>
      <Space h="xl" />
      <Group justify="right" gap="md">
        <Button variant="tertiary" size="lg" onClick={() => onClose()}>
          Don't cancel
        </Button>
        <Button variant="negative" size="lg" onClick={handleCancelInvite}>
          Cancel invitation
        </Button>
      </Group>
    </>
  );
};
